export const DATETIME_ISO_FORMAT_WITH_SLASHES = 'YYYY/MM/DD HH:mm';
export const DATE_WITH_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const SIMPLE_TIME_FORMAT = 'HH:mm:ss';

export const DATE_FORMAT_IN_READABLE_FORMAT = 'DD MMMM YYYY, HH:mm';
export const DATE_FORMAT_IN_COMPACT_READABLE_FORMAT = 'DD MMM YYYY, HH:mm';
export const DATE_FORMAT = 'YYYY MMMM DD, HH:mm';

export const SINGLE_DAY_DATE_FORMAT = 'ddd Do MMM YYYY';
export const FULL_DAY_DATE_FORMAT = 'dddd, D MMMM YYYY';
export const COMPACT_TIME_FORMAT = 'h:mm A';
export const TWENTY_FOUR_HOUR_TIME_FORMAT = 'HH:mm';

export const MONTH_YEAR_FORMAT = 'MMMM YYYY';
export const YEAR_MONTH_FORMAT = 'YYYY-MM';

export const DATE_ONLY_FORMAT = 'YYYY-MM-DD';

export const WEEK_VIEW_DATE_FORMAT = 'MMMM D';

export const DATE_HOUR_FORMAT = 'HH:00';

export const AVAILABILITY_CALENDAR_DATE_FORMAT = 'YYYY-MM-DD HH:00';

export const SLIDING_SESSION_TIME_FORMAT = 'hh:mm A - DD MMM YYYY';
